/**
 * Load local .js files (imports only)
*/

require('./bootstrap');
require('./global');
